var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message-next" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "message" }),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }, [
        _c("a", { attrs: { href: "#" } }, [_vm._v("click")]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary",
            on: { click: _vm.onClick }
          },
          [_vm._v("PROCEDI")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-770977c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-770977c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/MessageNext.vue
// module id = null
// module chunks = 